import { render, staticRenderFns } from "./AlfaSettingsBlock.vue?vue&type=template&id=7317f883&scoped=true&"
import script from "./AlfaSettingsBlock.vue?vue&type=script&lang=js&"
export * from "./AlfaSettingsBlock.vue?vue&type=script&lang=js&"
import style0 from "./AlfaSettingsBlock.vue?vue&type=style&index=0&id=7317f883&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7317f883",
  null
  
)

export default component.exports